import React, { useEffect } from 'react';
import { CreateJourneyCards } from 'src/common/components/create-journey/cards';
import JourneyListbox from 'src/common/form/JourneyListbox';
import { Workspace } from 'src/common/interfaces/workspace.interface';

import JourneySlideover, { DEFAULT_ANIMATION_DURATION } from 'src/common/JourneySlideOver';
import { useFilesUploadStore } from 'src/common/store/files-upload.store';
import useDashboardStore from 'src/dashboard/store/dashboard';
import { useNewJourneyStore } from 'src/dashboard/store/new-journey';
import { useUserOnboardingStore } from 'src/onboarding/store/user-onboarding.store';
import { useCurrentOrganization } from 'src/store/organization';
import { useCurrentUser } from 'src/store/user';

/**
 *
 * @deprecated
 */
const CreateJourneySlideover = () => {
  const setIsCreatingJourney = useDashboardStore((state) => state.setIsCreatingJourney);
  const isCreatingJourney = useDashboardStore((state) => state.isCreatingJourney);
  const { setOnboardingOpen, hasOnboardingTip } = useUserOnboardingStore((state) => ({
    hasOnboardingTip: !!state.tip,
    setOnboardingOpen: state.setOpen,
  }));
  const resetStore = useNewJourneyStore((state) => state.resetStore);
  const hasOngoingUploadCall = useFilesUploadStore((state) => state.getOngoingUploadStacks().length !== 0);

  const onClose = () => {
    setIsCreatingJourney(false);
    setOnboardingOpen(hasOngoingUploadCall || hasOnboardingTip);
    setTimeout(resetStore, DEFAULT_ANIMATION_DURATION);
  };

  useEffect(() => {
    if (isCreatingJourney) {
      setOnboardingOpen(false);
    }
  }, [isCreatingJourney]);

  return (
    <JourneySlideover
      title='Create new Journey'
      open={isCreatingJourney}
      onClose={onClose}
      maxWidth='xs'
      isBedrock
      skipClosingOnboarding
    >
      <div className='flex flex-col gap-6'>
        <JourneyWorkspaceSelect />
        <CreateJourneyCards containerClassName='flex flex-col gap-4' fromSidebar />
      </div>
    </JourneySlideover>
  );
};

export const JourneyWorkspaceSelect = () => {
  const setJourneyWorkspace = useNewJourneyStore((state) => state.setJourneyWorkspace);
  const journeyWorkspace = useNewJourneyStore((state) => state.journeyWorkspace);
  const currentUser = useCurrentUser((state) => state.currentUser);
  const getMemberWorkspaces = useCurrentOrganization((state) => state.getMemberWorkspaces);
  const memberWorkspaces = getMemberWorkspaces(currentUser);
  const teamWorkspace = useCurrentOrganization((state) => state.teamWorkspace);

  useEffect(() => {
    // if there is no workspace, set the default workspace to the team workspace or the first member workspace
    if (!journeyWorkspace) {
      setJourneyWorkspace(teamWorkspace || memberWorkspaces[0]);
    }
  }, [journeyWorkspace, memberWorkspaces, teamWorkspace, setJourneyWorkspace]);

  return (
    <div className='flex flex-col space-y-2'>
      <span className='text-bedrock-black text-bedrock-p-strong'>Workspace</span>
      <JourneyListbox
        listBoxClassName='w-[336px]'
        // listboxButtonClassName is not used in the component
        listboxButtonClassName='h-12 text-center'
        // listboxButtonContainerClassName is not used in the component
        listboxButtonContainerClassName='w-28'
        options={memberWorkspaces}
        onChange={(workspace: Workspace) => setJourneyWorkspace(workspace)}
        selected={journeyWorkspace}
        renderValue={(option: any) => option.name}
        renderKey={(option: any) => option.id}
      />
    </div>
  );
};

export default CreateJourneySlideover;
